document.addEventListener('DOMContentLoaded', () => {
    const videoBox = document.querySelector('.js-video-box');
    if (!videoBox) return;

    const video = videoBox.querySelector('.js-video');
    const overlay = videoBox.querySelector('.js-video-toggle');
    if (!video || !overlay) return;

    let isPlaying = false;

    const playVideo = () => {
        video.play();
        overlay.classList.add('is-hidden');
        isPlaying = true;
    };

    const pauseVideo = () => {
        video.pause();
        overlay.classList.remove('is-hidden');
        isPlaying = false;
    };

    overlay.addEventListener('click', playVideo);

    video.addEventListener('click', () => {
        isPlaying ? pauseVideo() : playVideo();
    });

    video.addEventListener('ended', pauseVideo);
});